import React from "react";
// import { Spinner } from 'react-activity';
// import 'react-activity/dist/react-activity.css';
// reactstrap components
import { Container, Row, Col } from "reactstrap";

class UserHeader extends React.Component {
  render() {
    const { name } = this.props
    // if (inProgress) {
    //   return (
    //     <>
    //       <Spinner
    //         animating={true}
    //         style={{ flex: 1, alignItems: "center", justifyContent: "center", height: 80 }}
    //         size="large"
    //       />
    //     </>
    //   );
    // }
    return (
      <>
        <div
          className="header pb-8 pt-5 pt-lg-8 d-flex align-items-center"
          style={{
            minHeight: "450px",
            backgroundImage:
              "url(" + require("../../assets/img/theme/profile-cover.jpg") + ")",
            backgroundSize: "cover",
            backgroundPosition: "center top"
          }}
        >
          {/* Mask */}
          <span className="mask bg-gradient-default1 opacity-8" />
          {/* Header container */}
          <Container className="d-flex align-items-center" fluid>
            <Row>
              <Col lg="7" md="10">
                <h1 className="display-2 text-white">Hello {name}</h1>
                <p className="text-white mt-0 mb-5">
                  This is your profile page. You can see the progress you've
                  made with your work and manage your profile or assigned tasks
                </p>
              </Col>
            </Row>
          </Container>
        </div>
      </>
    );
  }
}

export default UserHeader;
